import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";

import { auth } from "../firebase";

export default function CommitteeMembersEditor({ committee }) {
  const [members, setMembers] = useState(committee.members || []);
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    const fetchDirectory = async () => {
      try {
        const token = await auth.currentUser.getIdToken();
        const res = await axios.get("/api/directory", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setAllUsers(res.data);
      } catch (error) {
        console.error("Error fetching directory:", error);
        toast.error("Failed to fetch users");
      }
    };
    
    fetchDirectory();
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...members];
    updated[index][field] = value;
    setMembers(updated);
  };

  const handleAddMember = () => {
    setMembers([...members, { userId: "", role: "" }]);
  };

  const handleRemoveMember = (index) => {
    const updated = [...members];
    updated.splice(index, 1);
    setMembers(updated);
  };

  const saveMembers = async () => {
    try {
      const token = await auth.currentUser.getIdToken();
      await axios.patch(`/api/committees/${committee._id}/members`, members, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Members updated!");
    } catch {
      toast.error("Failed to update members");
    }
  };

  return (
  <div className="border p-3 mt-2 bg-light rounded">
    <p className="mb-2"><strong>Members</strong></p>

    {members.map((member, index) => (
      <div key={index} className="d-flex mb-2 gap-2 align-items-center" style={{ flexWrap: "nowrap" }}>
        <div style={{ flex: "2 1 0%", minWidth: 0 }}>
          <Select
            className="basic-single"
            options={allUsers.map(user => ({
              value: user._id,
              label: `${user.surname}, ${user.first_name}${user.known_as ? ` (${user.known_as})` : ""}`
            }))}
            value={allUsers
              .map(user => ({
                value: user._id,
                label: `${user.surname}, ${user.first_name}${user.known_as ? ` (${user.known_as})` : ""}`
              }))
              .find(option => option.value === member.userId)}
            onChange={(selectedOption) =>
              handleChange(index, "userId", selectedOption ? selectedOption.value : "")
            }
            isClearable
            placeholder="Select member"
            styles={{ container: (base) => ({ ...base, width: "100%" }) }}
          />
        </div>

        <div style={{ flex: "1 1 0%", minWidth: 0 }}>
          <input
            type="text"
            className="form-control"
            placeholder="Role"
            value={member.role}
            onChange={e => handleChange(index, "role", e.target.value)}
          />
        </div>

        <button className="btn btn-outline-secondary btn-sm" onClick={() => handleRemoveMember(index)}>×</button>
      </div>
    ))}

    <div className="d-flex gap-2 mt-2">
      <button className="btn btn-custom-outline btn-sm" onClick={handleAddMember}>
        + Add Member
      </button>
      <button className="btn btn-admin btn-sm" onClick={saveMembers}>
        Save Members
      </button>
    </div>
  </div>
);

}
